export default "/images/12c571ad1dacf598b79967ce4ab73224.avif";